import styled from "@emotion/styled";

export const CircularAvatar = styled.div`
background-color: ${({ bgColor }) => bgColor || "#74b1d4ff"};
border-radius: 50%;
width: ${({ circularSize }) => circularSize || "40px"};
height: ${({ circularSize }) => circularSize || "40px"};
display:flex;
align-items:center;
justify-content:center;
cursor: pointer;

  // @media(max-widht: 639px){
  //   width: 18px;
  //   height: 18px;
  // }

  // @media (min-width: 640px) {
  //   width: 22px;
  //   height: 22px;
  // }

  // /* md: ≥768px */
  // @media (min-width: 768px) {
  //   width: 40px;
  //   height: 40px;
  // }

  // /* lg: ≥1024px */
  // @media (min-width: 1024px) {
  //   width: 44px;
  //   height: 44px;
  // }

  // /* xl: ≥1280px */
  // @media (min-width: 1280px) {
  //   width: 48px;
  //   height: 48px;
  // }

  // /* 2xl: ≥1536px */
  // @media (min-width: 1536px) {
  //   width: 52px;
  //   height: 52px;
  // }

  // &:hover{
  //     background-color: lightgray;
  // }
`